import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  Inject,
  ViewChild,
  Directive,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { firstValueFrom, Subscription, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { DirectionService } from '../../direction.service';
import { DialogService } from 'src/app/dialog/dialog.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { CreditFormService } from 'src/app/other-pages/my-profile/credit-form-service';

import { Direction } from '@angular/cdk/bidi';
import { MatTooltip } from '@angular/material/tooltip';
import { DateAdapter } from '@angular/material/core';

import { Router } from '@angular/router';
import { UsersService } from 'src/app/super-management/user/users.service';

import lottie from 'lottie-web';
import { AuthService } from 'src/app/auth/auth.service';

import { OrdersService } from '../../main-section/printing-table/order.service';
import { ChatService } from '../../other-pages/chat/chat.service';
import { TranslateService } from '@ngx-translate/core';
import { DataSharingService } from 'src/app/main-section/data-shering-service/data-sharing.service';
import { WallSessionService } from 'src/app/wall/wall-session.service';
import { isWallPlaceholderThumb } from 'src/app/wall/wall-api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { set } from 'lodash';
import { BranchesService } from 'src/app/super-management/branch/branches.service';
import { environment } from 'src/environments/environment';
import { CommitmentTimeDisplayService } from 'src/app/services/commitment-time-display.service';
import { normalizeCardExpiryTwoDigits } from 'src/app/other-pages/my-profile/card-expiry-two-digits';
import { copyTextToClipboard } from 'src/app/utils/clipboard-copy';
import {
  getPhSystemIconSrcFromProduct,
  phProductMaterialI18nKey,
} from 'src/app/main-section/ph-printing-table/ph-service-data';

@Directive({
  selector: '[appPhoneFormatOrderSummery]',
})
export class PhoneFormatOrderSummeryDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this.el.nativeElement.value;

    this.el.nativeElement.value = initialValue
      .replace(/[^0-9]/g, '')
      .replace(/(\d{2})(\d{4})(\d{3})/, '0$1-$2-$3');

    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css'],
  host: {
    class: 'fill-screen-modal-order-summary',
    '[class.order-summary-wall-promo-fill]': 'shouldShowWallPromo() && !isLoading',
  },
})
export class OrderSummaryComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;

  isLoading: boolean = false;
  isLoadingText: string = '';
  isLoadingSendToPrint: boolean = false;
  isLoadingAproveOrderSummary: boolean = false;

  printingService: string;
  branchPapers: string;
  files: any;
  branchName: string;
  printerID: string;
  orderID: string;
  totalPriceData: any;
  user: any;
  isPendingOrder: boolean = false;
  isAdminOrder: boolean = false;
  branchUnique: number = 0;
  printingCode: number = 0;
  userPrintingCode: string = null;
  isPicsPrinter: boolean = false;
  is3D: boolean = false;
  picsDiscount: number = null;
  skipCode: boolean = false;
  forceRasterize: boolean = false;
  isLoadingPrintingCode: boolean = false;

  isCreditCardFieldsEmphasized: boolean = false;

  fixProducts: any;
  fixProductsArray: any = [];
  fixProductsOrderId: string = null;
  expressAttachedOrderId: string = null;

  isFixedProductsNeedsToBePayed: boolean = false;
  isFixedProductsAproved: boolean = false;
  isFixedProductsPayed: boolean = false;
  isFixedProductsPicked: boolean = false;

  isOrderAproved: boolean = false;
  isCreditMode: boolean = false;
  isLoadingUpdates = false;

  isOrderPrinted: boolean = false;
  isOrderSaved: boolean = false;

  /** Wall promo only after sending to print now — not after "print later" */
  shouldShowWallPromo(): boolean {
    if (!this.isOrderPrinted) {
      return false;
    }
    return localStorage.getItem('isNotAcademy') !== 'true';
  }

  hasUserWall(): boolean {
    return localStorage.getItem('haveWall') === 'true';
  }

  openPersonalWall(): void {
    // Slim payload only — full order files freeze the wall page / blow session size
    const sourceFiles = this.files || [];
    const skipReasons: Array<Record<string, unknown>> = [];
    const preparedFiles = sourceFiles
      .map((file: any, fileIndex: number) => {
        const fileId = this.extractWallFileId(file);
        const images = (file?.images || [])
          .map((img: any, imgIndex: number) => {
            const wallThumbUrl = this.resolveWallThumb(img);
            const thumbnailPath = String(img?.thumbnailPath || '').trim();
            const path = String(img?.path || '').trim();
            const page =
              Number(img?.page) >= 1 ? Number(img.page) : imgIndex + 1;
            if (
              isWallPlaceholderThumb(wallThumbUrl) &&
              isWallPlaceholderThumb(thumbnailPath) &&
              isWallPlaceholderThumb(path)
            ) {
              skipReasons.push({
                reason: 'empty-or-placeholder-thumb',
                fileIndex,
                imgIndex,
                page,
                wallThumbUrl,
                thumbnailPath,
                path,
              });
              return null;
            }
            return {
              page,
              wallThumbUrl: wallThumbUrl || thumbnailPath || path,
              thumbnailPath,
              path,
              wallRotation: 0,
            };
          })
          .filter(Boolean);
        if (!fileId) {
          skipReasons.push({
            reason: 'missing-file-id',
            fileIndex,
            keys: file ? Object.keys(file) : [],
          });
          return null;
        }
        if (!images.length) {
          skipReasons.push({
            reason: 'no-usable-images',
            fileIndex,
            fileId,
            rawImagesCount: file?.images?.length || 0,
          });
          return null;
        }
        return {
          _id: fileId,
          fileId,
          originalName: file?.originalName || file?.name || file?.fileName || '',
          name: file?.name || file?.originalName || '',
          images,
        };
      })
      .filter(Boolean);

    console.log('[WALL-SHARE] openPersonalWall', {
      sourceFilesCount: sourceFiles.length,
      preparedFilesCount: preparedFiles.length,
      preparedPagesCount: preparedFiles.reduce(
        (n, f) => n + (f?.images?.length || 0),
        0
      ),
      orderId: this.orderID,
      printingService: this.printingService,
      branchName: this.branchName,
      serverAddress: this.serverAddress,
      skipReasons,
    });

    this.wallSessionService.setWallSessionFiles(preparedFiles, {
      orderId: this.orderID,
      printingService: this.printingService,
      serverAddress: this.serverAddress,
      serialName: this.branchName,
      userName: String(this.user?.username || this.user?.email || '').trim(),
    });
    this.router.navigate(['/wall']).then((ok) => {
      console.log('[WALL-SHARE] navigate /wall result', ok);
      this.closeOrderSummaryDialog();
    });
  }

  private extractWallFileId(file: any): string {
    let id = file?._id || file?.fileId || file?.id;
    if (id && typeof id === 'object') {
      id = id._id || id.id || null;
    }
    return id ? String(id) : '';
  }

  private resolveWallThumb(img: any): string {
    if (!img) {
      return '';
    }
    let url = '';
    // Prefer non-rotated sources only (never rotatedThumbnailPath)
    if (this.printingService === 'plotter') {
      url = this.resolvePlotterWallThumb(img);
    } else if (this.printingService === 'express') {
      url = this.getImgExpressForWall(img);
    } else {
      url = img.thumbnailPath || img.path || '';
    }
    return isWallPlaceholderThumb(url) ? '' : url;
  }

  /** Plotter wall thumbs: S3 thumbnailPath (same as preview), not stale img-{serial} disk URLs. */
  private resolvePlotterWallThumb(img: any): string {
    const thumb = String(img?.thumbnailPath || '').trim();
    const path = String(img?.path || '').trim();
    const http = [thumb, path].find(
      (u) => /^https?:\/\//i.test(u) && !isWallPlaceholderThumb(u)
    );
    if (http) {
      return http;
    }
    const disk = [thumb, path].find(
      (u) =>
        u.startsWith('uploads') || u.startsWith('/home/ubuntu/IMG-Plotter')
    );
    if (disk && this.serverAddress) {
      if (disk.startsWith('uploads')) {
        return `${this.serverAddress}/${disk}`;
      }
      return (
        this.serverAddress + disk.replace('/home/ubuntu/IMG-Plotter', '')
      );
    }
    return thumb || path || this.getImgPlotter(img) || '';
  }

  private getImgExpressForWall(img: any): string {
    const EXPRESS_CDN = 'https://img-express.eazix.io';
    const thumb = String(img?.thumbnailPath || '').trim();
    const path = String(img?.path || '').trim();
    const disk = [thumb, path].find((p) =>
      p.startsWith('/home/ubuntu/IMG-Express')
    );
    if (disk) {
      return disk.replace('/home/ubuntu/IMG-Express', EXPRESS_CDN);
    }
    if (thumb.startsWith('http')) {
      return thumb;
    }
    if (path.startsWith('http')) {
      return path;
    }
    const fileName = (thumb || path).split(/[/\\]/).pop() || '';
    const serial = String(this.branchName || '').trim();
    const user = String(this.user?.username || this.user?.email || '').trim();
    if (
      fileName &&
      serial &&
      user &&
      !isWallPlaceholderThumb(fileName) &&
      !fileName.includes('box-icon')
    ) {
      return `https://${serial}.eazix.io/uploads/${user}/${fileName}`;
    }
    if (!isWallPlaceholderThumb(thumb)) {
      return thumb;
    }
    if (!isWallPlaceholderThumb(path)) {
      return path;
    }
    return '';
  }

  isCvvConfirmed: boolean = false;
  tryCeckCvv: number = 0;
  MaxCeckCvvTry: number = 10;
  isTooManyCvvTry: boolean = false;
  private hasCheckedExpressStatus: boolean = false;

  creditForm = this.creditFormService.createForm(null);
  isCompanyID: boolean = false;

  tooltipDirection: Direction = 'ltr';
  @ViewChild(MatTooltip) tooltip: MatTooltip;

  @ViewChild('monthInput') monthInput;
  @ViewChild('yearInput') yearInput;

  cvvForm: FormGroup;
  /** The user opened the phone dialog from this summary; continue the PH order once the phone is saved. */
  private waitingForPhone = false;
  private phoneUpdatedSub: Subscription;
  animation: any;
  confettiAnimation: any;

  isLottieStart: boolean = false;
  isLottieMiddle: boolean = false;
  isLottieEnd: boolean = false;

  isLogedIn: boolean = false;

  @ViewChild('expressInput') expressInput: ElementRef;
  @ViewChild('cvvInput') cvvInput: ElementRef;

  isAfterOptionBtnAnimated: boolean = false;
  serverAddress: string;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  isThumbnailsOK: boolean = true;

  isPH: boolean = false;
  /** PH summary header: 3D vs print — same assets as choose-product nav (3dprint-icon / phprint-icon) */
  phOrderSummarySystemIconSrc: string;
  collectionData: any = null;
  product3D: any = null;
  selectedPlace: any = null;

  private autoCloseTimeout: any;

  constructor(
    private directionService: DirectionService,
    private dialogService: DialogService,
    private elRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private creditFormService: CreditFormService,
    private dateAdapter: DateAdapter<Date>,
    private router: Router,
    private usersService: UsersService,
    private authService: AuthService,
    private ordersService: OrdersService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private translate: TranslateService,
    private dataSharingService: DataSharingService,
    private wallSessionService: WallSessionService,
    private snackBar: MatSnackBar,
    private branchesService: BranchesService,
    private chatService: ChatService,
    private commitmentTimeService: CommitmentTimeDisplayService
  ) {
    this.printingService = data.printingService;
    this.serverAddress = data.serverAddress;
    this.branchPapers = data.branchPapers;
    this.files = data.files || [];
    // console.log("this.files ORDERSUMMERY!", this.files);
    this.branchName = data.branchName;
    this.printerID = data.printerID;
    this.orderID = data.orderID || (data.phPaymentForOrder?.orderId || '');
    this.totalPriceData = data.totalPriceData;
    if (!this.totalPriceData?.fixProductsTotalPrice) {
      this.totalPriceData.fixProductsTotalPrice = 0;
    }
    this.user = data.user;
    this.isPendingOrder = data.isPendingOrder;
    this.isAdminOrder = data.isAdminOrder;
    this.branchUnique = data.branchUnique;
    this.creditForm = this.creditFormService.createForm(data.user);
    this.printingCode = data.printingCode;
    this.fixProducts = data.fixProducts;
    this.isPicsPrinter = data.isPicsPrinter ? data.isPicsPrinter : false;
    this.is3D =
      this.printingService === 'ph' && !!(data.is3DPrint ?? data.product3D);
    this.picsDiscount = data.picsDiscount ? data.picsDiscount : null;
    this.collectionData = data.collectionData ? data.collectionData : null;
    this.skipCode = data.skipCode ? data.skipCode : false;
    this.forceRasterize = data.forceRasterize === true;
    this.product3D = data.product3D || null;
    if (this.collectionData?.selectedPlace) {
      this.selectedPlace = this.collectionData.selectedPlace;
      // console.log("this.selectedPlace", this.selectedPlace);
    }
    this.phPaymentForOrder = data.phPaymentForOrder || null;
    this.emptyPaymentForOrder = data.emptyPaymentForOrder || null;
    this.phOrderSummarySystemIconSrc = getPhSystemIconSrcFromProduct(
      this.product3D || { name: this.branchName }
    );
  }

  phPaymentForOrder: { orderId: string; priceQuoteIndex: number; hasSavedCC?: boolean } | null = null;
  emptyPaymentForOrder: { fixProductsOrderId: string; expressOrderId?: string; totalCost: number; hasSavedCC?: boolean } | null = null;
  isPhPaymentSuccess: boolean = false;
  isEmptyPaymentSuccess: boolean = false;

  async ngOnInit() {
    this.isLoading = true;
    this.isPH = this.printingService === 'ph';
    this.phoneUpdatedSub = this.usersService.phoneUpdated.subscribe((phone: number) => this.onPhoneSaved(phone));
    // console.log('printingService:', this.printingService);
    // console.log('branchName:', this.branchName);
    if (
      !this.printingService ||
      !this.serverAddress ||
      this.branchPapers == null ||
      (!this.files?.length && !this.fixProducts && !this.emptyPaymentForOrder) ||
      !this.branchName ||
      !this.totalPriceData ||
      !this.user
    ) {
      if (
        localStorage.getItem('printingService') &&
        localStorage.getItem('branch')
      ) {
        if (!this.isPH) {
          this.router.navigate([
            '/qr/' +
            localStorage.getItem('printingService') +
            '/' +
            localStorage.getItem('branch'),
          ]);
        }
      }
      this.closeOrderSummaryDialog();
    }

    try {
      this.directionSubscription = this.directionService.direction$.subscribe(
        (direction) => {
          this.isRTL = direction === 'rtl';
          this.tooltipDirection = this.isRTL ? 'rtl' : 'ltr';
        }
      );

      this.directionService.isDarkMode$.subscribe((isDarkMode) => {
        this.isDarkMode = isDarkMode;
      });

      // Update printing code for express printers (only if admin or skipCode is enabled)
      if (
        this.printingService === 'express' &&
        (this.isAdminOrder || this.skipCode) &&
        !this.emptyPaymentForOrder
      ) {
        this.updatePrintingCode();
      }

      if (
        this.fixProducts &&
        this.fixProducts.products &&
        this.fixProducts.products.length > 0
      ) {
        this.isFixedProductsNeedsToBePayed = true;
        for (let i = 0; i < this.fixProducts.products.length; i++) {
          if (this.fixProducts.products[i].numOfCopies > 0) {
            this.fixProductsArray.push(this.fixProducts.products[i]);
          }
        }
        // console.log("this.fixProductsArray", this.fixProductsArray);
      }

      this.userIsAuthenticated = this.authService.getIsAuth();
      this.authStatusSub = this.authService
        .getAuthStatusListener()
        .subscribe((isAuthenticated) => {
          this.userIsAuthenticated = isAuthenticated;
          this.userId = this.authService.getUserId();
          if (this.userIsAuthenticated) {
            localStorage.setItem('dontOpenRP', 'true');
          }
        });

      if (this.userIsAuthenticated) {
        // ---------- user is logedin
        this.isLogedIn = true;
        if (this.user) {
          // Credit Form
          this.creditForm = this.creditFormService.createForm(this.user);
          if (this.user.zCreditInfo && this.user.zCreditInfo.customerID) {
            this.isCompanyID = true;
          }
        } else {
          // Credit Form
          this.creditForm = this.creditFormService.createForm(null);
        }
        this.cvvForm = new FormGroup({
          cvv: new FormControl(null, {
            validators: [
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(4),
              Validators.pattern(/^\d+$/),
            ],
          }),
        });
        // // ---------- user is logedin
      } else {
        // ---------- user is not logedin
        this.isLogedIn = false;
        if (!localStorage.getItem('userId')) {
          this.authService.logout(false);
        }
        // // ---------- user is not logedin
      }
      if (this.phPaymentForOrder) {
        this.isOrderAproved = true;
        if (this.phPaymentForOrder.hasSavedCC) {
          this.isLoading = true;
          this.isLoadingText = 'ph-payment';
          setTimeout(() => this.payPhOrderWithSavedCC(), 0);
        } else {
          this.isCreditMode = true;
          this.isLoading = false;
        }
      } else if (this.emptyPaymentForOrder) {
        this.isOrderAproved = true;
        this.totalPriceData = {
          ...this.totalPriceData,
          totalOrderPrice: this.emptyPaymentForOrder.totalCost,
          totalOrderPriceBeforeDiscount: this.emptyPaymentForOrder.totalCost,
          points: 0,
          fixProductsTotalPrice: 0,
        };
        if (this.emptyPaymentForOrder.hasSavedCC) {
          this.isLoading = true;
          this.isLoadingText = 'ph-payment';
          setTimeout(() => this.payEmptyPaymentRequestWithSavedCC(), 0);
        } else {
          this.isCreditMode = true;
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
      }
    } catch (error) {
      console.error('error', error);
      if (
        localStorage.getItem('printingService') &&
        localStorage.getItem('branch')
      ) {
        this.router.navigate([
          '/qr/' +
          localStorage.getItem('printingService') +
          '/' +
          localStorage.getItem('branch'),
        ]);
      } else {
        this.router.navigate(['/']);
      }
    }
    this.autoCloseTimeout = setTimeout(() => {
      this.closeOrderSummaryDialog();
    }, 3 * 60 * 60 * 1000);
  }

  closeOrderSummaryDialog() {
    this.dialogService.onCloseOrderSummaryDialog();
  }

  navigateTo3DTechnologySelection() {
    this.router.navigate(['/3dproduct']);
    this.closeOrderSummaryDialog();
  }

  approveOrderSummary() {
    if (this.phPaymentForOrder || this.emptyPaymentForOrder) {
      return;
    }
    console.log('[ORDER-SUMMARY] approveOrderSummary clicked', {
      is3D: this.is3D,
      isPH: this.isPH,
      printingService: this.printingService,
      isPendingOrder: this.isPendingOrder,
      isAdminOrder: this.isAdminOrder
    });
    if (this.isLoadingAproveOrderSummary) {
      return; // Prevent multiple clicks
    }
    this.isLoadingAproveOrderSummary = true;
    this.isAfterOptionBtnAnimated = false;
    this.playAnimation();
    setTimeout(() => {
      this.isOrderAproved = true;
      if (this.printingService === 'plotter' && this.isPendingOrder) {
        this.onSendOrderToPrint();
      }
      setTimeout(() => {
        this.isLoadingAproveOrderSummary = false;
      }, 1000);
      if (this.isPH && this.isAdminOrder) {
        this.isCvvConfirmed = true;
        if (this.isPH && this.user.phone && this.user.phone !== '') {
          this.onCreatePHOrder();
        }
      }
      // 3D – שליחה ישירה ל-BACK בלי כרטיס אשראי/CVV (לפני בדיקת credit)
      if (this.is3D && this.isPH && this.user?._id) {
        this.isLoadingAproveOrderSummary = false; // מאפשר ל-onCreatePHOrder להמשיך (הוא מסמן loading מחדש)
        this.onCreatePHOrder();
        return;
      }
      if (
        (!this.user.zCreditInfo?.token || this.user.zCreditInfo.token === '') &&
        !(this.user.discount && this.user.discount === 100) &&
        !this.isAdminOrder &&
        !this.hasEnoughPointsToCoverOrder()
      ) {
        this.isCreditMode = true;
        this.isCreditCardFieldsEmphasized = false;
        return;
      }
      if (this.hasEnoughPointsToCoverOrder()) {
        this.isCvvConfirmed = true;
      }
      // [express] - If code input should be visible (user has token, is admin, points cover, or is pending order)
      // then check printer status
      if (this.printingService === 'express' && this.user?.phone && this.user.phone !== '') {
        if (this.isAdminOrder || this.isPendingOrder ||
            (this.user.zCreditInfo?.token && this.user.zCreditInfo.token !== '') ||
            (this.user.discount && this.user.discount === 100) ||
            this.hasEnoughPointsToCoverOrder()) {
          this.checkExpressPrinterStatusIfNeeded();
        }
      }
    }, 1900);
  }

  disaproveOrderSummary() {
    this.isOrderAproved = false;
    this.isLottieStart = false;
    this.isLottieEnd = false;
    this.isLottieStart = false;
    this.isCreditCardFieldsEmphasized = false;
    this.cvvForm.get('cvv').setErrors(null);
    if (this.animation) {
      this.animation.stop();
    }
  }

  getCCLastDigits(cc: string): string {
    if (!cc) {
      return '';
    }
    const ccStr = cc.toString();
    if (ccStr.length >= 4) {
      return ccStr;
    } else {
      return ccStr.padStart(4, '0');
    }
  }

  /** תצוגת מועד התחייבות אחידה – משתמש ב-CommitmentTimeDisplayService (מ-collectionData) */
  getCommitmentDisplayText(): string {
    const cd = this.collectionData;
    if (!cd?.selectedCollectOption) return '';
    const date = (cd.obligatedDate || '').toString().trim();
    return this.commitmentTimeService.getCommitmentTimeDisplayText({
      selectedCollectOption: cd.selectedCollectOption as 'pickup' | 'points' | 'delivery',
      obligatedDay: cd.obligatedDay,
      obligatedDate: date,
      obligatedTime: cd.obligatedTime,
      collectionDaysDiff: this.commitmentTimeService.computeCollectionDaysDiff(date),
    });
  }

  editCCOrderSummary() {
    const ordersUserId = this.user._id.toString();
    this.cvvForm.get('cvv').setErrors(null);
    if (
      this.isLogedIn &&
      this.userIsAuthenticated &&
      localStorage.getItem('userId') &&
      localStorage.getItem('userId') !== '' &&
      ordersUserId &&
      ordersUserId !== '' &&
      localStorage.getItem('userId') === ordersUserId
    ) {
      this.isCreditMode = true;
      this.isCreditCardFieldsEmphasized = false;
    } else {
      if (
        !localStorage.getItem('userId') ||
        localStorage.getItem('userId') === '' ||
        !ordersUserId ||
        ordersUserId === '' ||
        localStorage.getItem('userId') !== ordersUserId
      ) {
        this.authService.logout(false);
      }
      this.dialogService.onOpenLoginDialog();
    }
  }

  backToOrderCCOrderSummary() {
    this.isCreditMode = false;
  }

  /** True when user's points cover the full order (no payment method needed, like manager) */
  hasEnoughPointsToCoverOrder(): boolean {
    if (this.emptyPaymentForOrder) {
      return false;
    }
    if (!this.totalPriceData?.points || this.totalPriceData.points <= 0) {
      return false;
    }
    const totalToPay = (this.totalPriceData.totalOrderPrice || 0) + (this.totalPriceData.fixProductsTotalPrice || 0);
    return this.totalPriceData.points >= totalToPay;
  }

  // [general]
  roundDownTowDecimal(num: number): number {
    return Math.round(num * 100) / 100;
  }

  getSizePlotter(size: number) {
    return Math.round((size / 300) * 2.54 * 100) / 100;
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
    }
    this.phoneUpdatedSub?.unsubscribe();
  }

  async onSaveOrderForAfter() {
    if (
      (this.user.zCreditInfo?.token && this.user.zCreditInfo.token !== '') ||
      this.user.roles.includes('su') ||
      this.isAdminOrder ||
      this.user.discount === 100 ||
      this.hasEnoughPointsToCoverOrder()
    ) {
      // create array of file ids - ensure they are strings, not objects
      const filesIds = this.files
        .map((file) => {
          // Extract fileId - handle both string and object formats
          const fileId = file?.fileId || file?._id || file?.id;
          // If it's an object, extract the _id property
          if (fileId && typeof fileId === 'object') {
            return fileId._id || fileId.id || null;
          }
          // Return as string
          return fileId ? String(fileId) : null;
        })
        .filter((id) => id !== null && id !== undefined && id !== '');
      
      // Log for debugging (dev only)
      if (!environment.production) {
        console.log('[ORDER-SUMMARY] Extracted fileIds:', filesIds);
        console.log('[ORDER-SUMMARY] Original files structure:', this.files.map(f => ({ fileId: f.fileId, _id: f._id, id: f.id })));
      }
      // create order
      this.isLoading = true;
      // [plotter]
      if (this.printingService === 'plotter') {
        const branchTranslatedName = this.translate.instant(
          'choose-branch.naming.plotter.' + this.branchName
        );
        this.ordersService.createPlotterOrder(
          filesIds,
          this.printerID,
          branchTranslatedName,
          false
        ).subscribe(
          (response: any) => {
            if (response.message === 'Order created successfully') {
              setTimeout(() => {
                this.playAnimation();
                setTimeout(() => {
                  this.isLoading = false;
                  this.isOrderSaved = true;
                  this.playConfettiAnimation();
                  this.updatePendingOrderStatus();
                }, 1900);
              }, 1000);
              if (response.order && response.order._id) {
                this.orderID = response.order._id;
              }
            }
          },
          (error) => {
            console.log('error', error);
            this.isLoading = false;
          }
        );
        // [express]
      } else if (this.printingService === 'express') {
        const branchTranslatedName = this.translate.instant(
          'choose-branch.naming.express.' + this.branchName
        );
        this.ordersService.createExpressOrder(
          filesIds,
          this.printerID,
          null,
          branchTranslatedName,
          false,
          null,
          null,
          this.picsDiscount
        ).subscribe(
          (response: any) => {
            if (response.message === 'Order created successfully') {
              setTimeout(() => {
                this.playAnimation();
                setTimeout(() => {
                  this.isLoading = false;
                  this.isOrderSaved = true;
                  this.playConfettiAnimation();
                  this.updatePendingOrderStatus();
                }, 1900);
              }, 1000);
              if (response.order && response.order._id) {
                this.orderID = response.order._id;
              }
            }
          },
          (error) => {
            console.log('error', error);
            this.isLoading = false;
          }
        );
      }
    } else {
      this.isCreditMode = true;
      this.isCreditCardFieldsEmphasized = false;
    }
  }

  async payFixProducts() {
    // console.log("payFixProducts", this.fixProductsArray);
    this.isFixedProductsAproved = true;
    this.isLoading = true;
    // [express] - fix products
    if (
      this.printingService === 'express' &&
      this.fixProductsArray &&
      this.fixProductsArray.length > 0 &&
      this.isFixedProductsNeedsToBePayed
    ) {
      try {
        const branchTranslatedName = this.translate.instant(
          'choose-branch.naming.plotter.' + this.branchName
        );
        // const isOrderHasOnlyFixProducts = !(this.files && this.files.length > 0);
        // console.log("isOrderHasOnlyFixProducts", isOrderHasOnlyFixProducts);
        const response: any = await firstValueFrom(
          this.ordersService.createFixProductsOrder(
            this.fixProductsArray,
            this.printerID,
            branchTranslatedName
          )
        );
        if (response.message === 'Fix products order created successfully') {
          // console.log("Fix products order created successfully");
          this.isFixedProductsNeedsToBePayed = false;
          this.isFixedProductsPayed = true;
          this.fixProductsOrderId = response.fixProductsOrderId;
          this.expressAttachedOrderId = response.expressAttachedOrderId;
        } else {
          this.isFixedProductsAproved = false;
        }
        this.isLoading = false;
        this.isLoadingText = '';
      } catch (error) {
        console.error('Error creating fix products order:', error);
        this.isFixedProductsAproved = false;
        this.isLoading = false;
        this.isLoadingText = '';
      }
    } else {
      this.isFixedProductsAproved = false;
      this.isLoading = false;
    }
  }

  onPickedFixProducts() {
    this.isFixedProductsPicked = true;
    this.dataSharingService.notifyFixProductsOrderCreated();
    if (this.files && this.files.length > 0) {
      this.onSendOrderToPrint(this.userPrintingCode);
    } else {
      this.openRightPlaceDialog();
    }
  }

  updatePendingOrderStatus() {
    this.dataSharingService.notifyPendingOrderIncrement();
  }

  // [plotter]
  getImgPlotter(img) {
    let newThumbnail = '';
    const path = String(img?.path || '').trim();
    if (!path) {
      return '';
    }
    if (this.isPendingOrder) {
      if (path.startsWith('uploads')) {
        newThumbnail = this.serverAddress + '/' + path;
      } else {
        const shortThumbnail = path.replace('/home/ubuntu/IMG-Plotter', '');
        newThumbnail = this.serverAddress + shortThumbnail;
      }
    } else {
      newThumbnail = path;
    }
    if (this.isThumbnailsOK) {
      // this.checkThambnail(newThumbnail);
    }
    return newThumbnail;
  }

  checkThambnail(thumbnail: string) {
    const img = new Image();
    img.src = thumbnail;
    img.onload = () => {
      this.isThumbnailsOK = true;
    };
    img.onerror = () => {
      this.isThumbnailsOK = false;
    };
  }

  async onSendOrderToPrint(printingCode: string = null) {
    if (this.emptyPaymentForOrder) {
      return;
    }
    if (this.isFixedProductsNeedsToBePayed && !this.isFixedProductsPayed) {
      if (printingCode && parseInt(printingCode)) {
        this.userPrintingCode = printingCode;
        this.payFixProducts();
      }
      return;
    }
    if (
      (this.user.zCreditInfo?.token && this.user.zCreditInfo.token !== '') ||
      this.user.roles.includes('su') ||
      this.isAdminOrder ||
      this.user.discount === 100 ||
      this.hasEnoughPointsToCoverOrder()
    ) {
      this.isLoading = true;

      this.isLoadingText = 'prepering-files';
      setTimeout(() => {
        if (this.isLoadingText !== '') {
          this.isLoadingText = 'prepering-order';
          setTimeout(() => {
            if (this.isLoadingText !== '') {
              this.isLoadingText = 'sending-order';
            }
          }, 6000);
        }
      }, 6000);

      if (
        !this.orderID &&
        this.files &&
        this.files.length > 0 &&
        !this.isPendingOrder
      ) {
        // console.log("creating order");
        // create array of file ids - ensure they are strings, not objects
        const filesIds = this.files
          .map((file) => {
            // Extract fileId - handle both string and object formats
            const fileId = file?.fileId || file?._id || file?.id;
            // If it's an object, extract the _id property
            if (fileId && typeof fileId === 'object') {
              return fileId._id || fileId.id || null;
            }
            // Return as string
            return fileId ? String(fileId) : null;
          })
          .filter((id) => id !== null && id !== undefined && id !== '');
        
        // Log for debugging (dev only)
        if (!environment.production) {
          console.log('[ORDER-SUMMARY] Extracted fileIds (async):', filesIds);
          console.log('[ORDER-SUMMARY] Original files structure:', this.files.map(f => ({ fileId: f.fileId, _id: f._id, id: f.id })));
        }
        // [plotter]
        if (this.printingService === 'plotter') {
          try {
            const branchTranslatedName = this.translate.instant(
              'choose-branch.naming.plotter.' + this.branchName
            );
            const response = await firstValueFrom(
              this.ordersService.createPlotterOrder(
                filesIds,
                this.printerID,
                branchTranslatedName,
                true
              )
            );
            // console.log('Success:', response);
            this.orderID = response.order._id;
          } catch (error) {
            console.error('Error creating order:', error);
            this.isLoading = false;
            this.isLoadingText = '';
            return; // Stop execution if order creation fails
          }
          // [express]
        } else if (this.printingService === 'express') {
          try {
            const response: any = await firstValueFrom(
              this.ordersService.createExpressOrder(
                filesIds,
                this.printerID,
                printingCode,
                null,
                true,
                this.fixProductsOrderId,
                this.expressAttachedOrderId,
                this.picsDiscount
              )
            );
            if (response.message === 'Order created successfully') {
              // console.log("order created successfully");
              this.orderID = response.order._id;
            }
          } catch (error) {
            console.error('Error creating order:', error);
            this.isLoading = false;
            this.isLoadingText = '';
            this.isFixedProductsAproved = false;
            this.isFixedProductsPayed = false;
            return; // Stop execution if order creation fails
          }
        }
      }

      this.isLoading = true;
      this.isLoadingSendToPrint = true;

      // [plotter]
      if (this.printingService === 'plotter') {
        this.httpClient
          .post(this.serverAddress + '/api/orders/print', {
            orderID: this.orderID,
          })
          .subscribe({
            next: (response) => {
              // Success handling
              // console.log('Success:', response);
              this.playSentToPrintAnimation();
            },
            error: (error) => {
              // Failure handling
              console.error('Error:', error);
              this.isLoadingSendToPrint = false;
              if (error.error.message === 'PAYMENT_ERROR') {
                this.isCreditMode = true;
                this.isCreditCardFieldsEmphasized = false;
              } else if (error.error.message === 'ORDER_ALREADY_IN_QUEUE') {
                this.playSentToPrintAnimation();
              }
              this.isLoading = false;
              this.isLoadingText = '';
            },
          });

        // [express]
      } else if (this.printingService === 'express') {
        const printBody: {
          code: number | string;
          orderID: string;
          forceRasterize?: boolean;
        } = {
          code: printingCode,
          orderID: this.orderID,
        };
        if (this.forceRasterize) {
          printBody.forceRasterize = true;
        }
        this.httpClient
          .post(this.serverAddress + '/api/orders/print', printBody)
          .subscribe({
            next: (response) => {
              // Success handling
              // console.log('Success:', response);
              this.playSentToPrintAnimation();
            },
            error: (error) => {
              // Failure handling
              // console.error('Error:', error);
              this.isLoadingSendToPrint = false;
              if (error.error.message === 'PAYMENT_ERROR') {
                this.isCreditMode = true;
                this.isCreditCardFieldsEmphasized = false;
              } else if (error.error.message === 'ORDER_ALREADY_IN_QUEUE') {
                this.playSentToPrintAnimation();
              } else {
                this.isFixedProductsAproved = false;
                this.isFixedProductsPayed = false;
              }
              this.isLoading = false;
              this.isLoadingText = '';
            },
          });
      } else {
        this.playSentToPrintAnimation();
      }
      // if no resposne from server after 10 seconds
      setTimeout(() => {
        this.onCheckOrdersStatus();
      }, 10000);
    } else {
      this.isLoadingText = '';
      this.isLoading = false;
      this.isCreditMode = true;
      this.isCreditCardFieldsEmphasized = false;
    }
  }

  onCheckOrdersStatus(attempt: number = 1) {
    // console.log("onCheckOrdersStatus attempt:", attempt);
    if (this.isLoadingSendToPrint && this.printingService && this.orderID) {
      this.ordersService.checkOrderStatus(
        this.printingService,
        this.orderID
      ).subscribe(
        (response: any) => {
          if (this.isLoadingSendToPrint) {
            if (response.status && response.status === 'INQUEUE') {
              this.isLoadingSendToPrint = false;
              this.playSentToPrintAnimation();
            } else if (attempt < 10) {
              setTimeout(() => this.onCheckOrdersStatus(attempt + 1), 2000);
            } else {
              this.isLoadingSendToPrint = false;
              this.isLoadingText = '';
              this.isOrderPrinted = false;
            }
          }
        },
        (error) => {
          if (this.isLoadingSendToPrint) {
            if (attempt < 10) {
              setTimeout(() => this.onCheckOrdersStatus(attempt + 1), 2000);
            } else {
              this.isLoadingSendToPrint = false;
              this.isLoadingText = '';
              this.isOrderPrinted = false;
            }
          }
        }
      );
    }
  }

  onSaveCreditCard() {
    if (
      this.creditForm.get('cardNum').invalid ||
      this.creditForm.get('month').invalid ||
      this.creditForm.get('year').invalid ||
      this.creditForm.get('cardCvv').invalid ||
      this.creditForm.get('cardHolderName').invalid ||
      this.creditForm.get('cardHolderID').invalid
    ) {
      return;
    }
    let cc = {
      exp_m: normalizeCardExpiryTwoDigits(this.creditForm.value.month),
      exp_y: normalizeCardExpiryTwoDigits(this.creditForm.value.year),
      num: this.creditForm.value.cardNum.replace(/-/g, ''),
      cvv: this.creditForm.value.cardCvv,
      id: this.creditForm.value.cardHolderID,
      name: this.creditForm.value.cardHolderName,
      customerName:
        this.creditForm.value.cardCustomerName &&
          this.creditForm.value.cardCustomerName !== ''
          ? this.creditForm.value.cardCustomerName
          : this.user.username,
      customerEmail:
        this.creditForm.value.billingEmail &&
          this.creditForm.value.billingEmail !== ''
          ? this.creditForm.value.billingEmail
          : this.user.email,
      customerBusinessID:
        this.isCompanyID &&
          this.creditForm.value.cardCompanyID &&
          this.creditForm.value.cardCompanyID !== ''
          ? this.creditForm.value.cardCompanyID
          : null,
    };
    if (this.phPaymentForOrder) {
      this.isLoading = true;
      this.isLoadingText = 'ph-payment';
      this.chatService.payPHOrder(
        this.phPaymentForOrder.orderId,
        this.phPaymentForOrder.priceQuoteIndex,
        cc
      ).subscribe({
        next: () => {
          this.playPhPaymentSuccessAnimation();
          this.dataSharingService.notifyPhOrderCreated();
          this.dataSharingService.notifyPendingOrderIncrement();
          setTimeout(() => this.dialogService.onCloseOrderSummaryDialog(), 2500);
        },
        error: (err) => {
          this.isLoading = false;
          this.isLoadingText = '';
          const isPaymentError = err?.error?.message === 'PAYMENT_ERROR' || err?.error?.error === 'PAYMENT_ERROR';
          if (isPaymentError) {
            this.isCreditMode = true;
            this.isCreditCardFieldsEmphasized = false;
          }
          /* שגיאה שאינה PAYMENT_ERROR מוצגת בדיאלוג דרך ErrorInterceptor */
        },
      });
      return;
    }
    if (this.emptyPaymentForOrder) {
      this.isLoading = true;
      this.isLoadingText = 'ph-payment';
      this.usersService
        .updateUserCC(localStorage.getItem('userId'), cc)
        .subscribe({
          next: (response: any) => {
            if (response.user?.zCreditInfo?.token) {
              this.user.zCreditInfo = response.user.zCreditInfo;
              this.payEmptyPaymentRequestWithSavedCC();
            } else {
              this.isLoading = false;
              this.isLoadingText = '';
            }
          },
          error: () => {
            this.isLoading = false;
            this.isLoadingText = '';
          },
        });
      return;
    }
    // console.log("cc", cc);
    this.usersService
      .updateUserCC(localStorage.getItem('userId'), cc)
      .subscribe((response: any) => {
        if (
          response.user?.zCreditInfo?.token &&
          response.user.zCreditInfo.token !== '' &&
          response.user?.zCreditInfo?.cardNum &&
          response.user.zCreditInfo.cardNum !== '' &&
          response.user?.zCreditInfo?.cardExp &&
          response.user.zCreditInfo.cardExp !== '' &&
          response.user?.zCreditInfo?.cvv &&
          response.user.zCreditInfo.cvv !== ''
        ) {
          this.scrollToTop();
          setTimeout(() => {
            this.playAnimation();
            setTimeout(() => {
              this.isCvvConfirmed = true;
              this.tryCeckCvv = 0;
              this.isCreditMode = false;
              this.user.zCreditInfo = response.user.zCreditInfo;
              this.creditForm = this.creditFormService.createForm(this.user);
              if (this.emptyPaymentForOrder) {
                this.payEmptyPaymentRequestWithSavedCC();
              } else {
                this.checkExpressPrinterStatusIfNeeded();
                if (this.isPH && this.user.phone && this.user.phone !== '') {
                  this.onCreatePHOrder();
                } else {
                  this.isLoading = false;
                }
              }
            }, 1600);
          }, 100);
        }
      });
  }

  payPhOrderWithSavedCC(): void {
    if (!this.phPaymentForOrder) return;
    this.chatService.payPHOrder(
      this.phPaymentForOrder.orderId,
      this.phPaymentForOrder.priceQuoteIndex
    ).subscribe({
      next: () => {
        this.playPhPaymentSuccessAnimation();
        this.dataSharingService.notifyPhOrderCreated();
        this.dataSharingService.notifyPendingOrderIncrement();
        setTimeout(() => this.dialogService.onCloseOrderSummaryDialog(), 2500);
      },
      error: (err) => {
        this.isLoading = false;
        this.isLoadingText = '';
        const isPaymentError = err?.error?.message === 'PAYMENT_ERROR' || err?.error?.error === 'PAYMENT_ERROR';
        if (isPaymentError) {
          this.isCreditMode = true;
          this.phPaymentForOrder = { ...this.phPaymentForOrder, hasSavedCC: false };
        }
        /* שגיאה שאינה PAYMENT_ERROR מוצגת בדיאלוג דרך ErrorInterceptor */
      },
    });
  }

  payEmptyPaymentRequestWithSavedCC(): void {
    const fixId = this.emptyPaymentForOrder?.fixProductsOrderId;
    if (!fixId) {
      this.showEmptyPaymentCreditFormAfterFailure();
      return;
    }
    this.isCreditMode = false;
    this.isLoading = true;
    this.isLoadingText = 'ph-payment';
    this.ordersService.payEmptyFixProductsOrder(fixId).subscribe({
      next: () => {
        this.playEmptyPaymentSuccessAnimation();
        this.dataSharingService.notifyPendingOrderIncrement();
        setTimeout(() => this.dialogService.onCloseOrderSummaryDialog(), 2500);
      },
      error: () => {
        this.showEmptyPaymentCreditFormAfterFailure();
      },
    });
  }

  /** בקשת תשלום ריקה בלבד – אחרי כשל תשלום/מזהה חסר, הצגת טופס אשראי (לא חלונית ריקה) */
  private showEmptyPaymentCreditFormAfterFailure(): void {
    if (!this.emptyPaymentForOrder) {
      return;
    }
    this.isLoading = false;
    this.isLoadingText = '';
    this.isCreditMode = true;
    this.isCreditCardFieldsEmphasized = false;
    this.emptyPaymentForOrder = {
      ...this.emptyPaymentForOrder,
      hasSavedCC: false,
    };
  }

  retryEmptyPaymentRequest(): void {
    if (!this.emptyPaymentForOrder) {
      return;
    }
    const hasSavedCC = !!(
      this.user?.zCreditInfo?.token && this.user.zCreditInfo.token !== ''
    );
    if (hasSavedCC) {
      this.emptyPaymentForOrder = { ...this.emptyPaymentForOrder, hasSavedCC: true };
      this.payEmptyPaymentRequestWithSavedCC();
    } else {
      this.isCreditMode = true;
    }
  }

  playEmptyPaymentSuccessAnimation(): void {
    this.isLoadingSendToPrint = false;
    this.isLoadingText = '';
    setTimeout(() => {
      this.playAnimation();
      setTimeout(() => {
        this.isLoading = false;
        this.isOrderPrinted = true;
        this.isPhPaymentSuccess = true;
        this.isEmptyPaymentSuccess = true;
        this.playConfettiAnimation();
      }, 1900);
    }, 1000);
  }

  playPhPaymentSuccessAnimation(): void {
    this.isLoadingSendToPrint = false;
    this.isLoadingText = '';
    setTimeout(() => {
      this.playAnimation();
      setTimeout(() => {
        this.isLoading = false;
        this.isOrderPrinted = true;
        this.isPhPaymentSuccess = true;
        this.playConfettiAnimation();
      }, 1900);
    }, 1000);
  }

  emphasizeCreditCardFields() {
    if (
      this.creditForm.get('cardNum').valid &&
      this.creditForm.get('month').valid &&
      this.creditForm.get('year').valid &&
      this.creditForm.get('cardCvv').valid &&
      this.creditForm.get('cardHolderName').valid &&
      this.creditForm.get('cardHolderID').valid
    ) {
      this.isCreditCardFieldsEmphasized = false;
      return;
    }
    this.isCreditCardFieldsEmphasized = true;
  }

  playSentToPrintAnimation() {
    this.isLoadingSendToPrint = false;
    this.isLoadingText = '';
    setTimeout(() => {
      this.playAnimation();
      setTimeout(() => {
        this.isLoading = false;
        this.isOrderPrinted = true;
        this.playConfettiAnimation();
      }, 1900);
    }, 1000);
  }

  onDeleteCreditCard() {
    this.usersService
      .deleteUserCC(localStorage.getItem('userId'), this.user.zCreditInfo)
      .subscribe((response: any) => {
        if (
          response.message === 'Credit card information deleted successfully'
        ) {
          this.user.zCreditInfo = null;
          this.creditForm = this.creditFormService.createForm(this.user);
          this.scrollToTop();
          setTimeout(() => {
            this.playAnimation();
            setTimeout(() => {
              this.isLoading = false;
            }, 1600);
          }, 100);
        }
      });
  }

  // Card Number
  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  formatCardNumInput(event): void {
    let input = event.target.value.replace(/\D/g, '');
    if (input.length > 16) {
      input = input.slice(0, 16);
    }
    input = input.replace(/(.{4})/g, '$1-');
    if (input.endsWith('-')) {
      input = input.slice(0, -1);
    }
    this.creditForm.get('cardNum').setValue(input, { emitEvent: false });
  }

  focusMonthIfEmpty() {
    if (
      !this.creditForm.get('month').value ||
      this.creditForm.get('month').value === ''
    ) {
      this.creditForm.get('month').setValue(null);
      this.monthInput.nativeElement.focus();
    }
  }

  creditCardValidator(control: FormControl): { [s: string]: boolean } | null {
    if (!control.value) {
      return null;
    }
    const pattern = /^\d{4}-\d{4}-\d{4}-\d{4}$/;
    if (!control.value.match(pattern)) {
      return { invalidCreditCard: true };
    }
    return null;
  }

  clearCreditField(field: string) {
    // console.log('clearCreaditFields = field', field);
    this.creditForm.get(field).setValue(this.user[field]);
  }

  toggleTooltip() {
    if (this.tooltip._isTooltipVisible()) {
      this.tooltip.hide();
    } else {
      this.tooltip.show();
    }
  }

  toggleCompanyID() {
    this.isCompanyID = !this.isCompanyID;
    // find a div with the id of
  }

  openWhatsApp() {
    const phoneNumber = '97233746962';
    const message = encodeURIComponent('After-Sending-To-Print');
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  }

  openWhatsAppFor3D() {
    const phoneNumber = '97233746962';
    const message = encodeURIComponent('3D-Printing-At-Eazix');
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  }

  openRightPlaceDialog() {
    if (this.isLogedIn) {
      this.dialogService.onOpenRightPlaceDialog();
    } else {
      this.dialogService.onOpenLoginDialog();
    }
    this.closeOrderSummaryDialog();
  }

  goToMyOrders() {
    this.router.navigate([`/myorders/${localStorage.getItem('userId')}`]);
    this.closeOrderSummaryDialog();
  }

  goToOrderChat() {
    // תמיד לשלוח את מזהה המשתמש המחובר (Auth) ב-URL – נדרש ל-checkAuthPrivate בבאק
    const userId = localStorage.getItem('userId') ?? this.user?._id;
    if (userId != null && this.orderID) {
      this.router.navigate([`/chat/user/${String(userId)}/${this.orderID}`]);
    } else {
      this.goToMyOrders();
    }
    this.closeOrderSummaryDialog();
  }

  goToPrintingQueue() {
    this.router.navigate(['/queue/' + this.branchUnique]);
    this.closeOrderSummaryDialog();
  }

  // PHONE — added with an SMS code in the phone dialog (PhoneComponent)
  onAddPhone() {
    this.waitingForPhone = true;
    this.dialogService.onOpenPhoneDialog();
  }

  clearCvvField() {
    this.cvvForm.patchValue({
      cvv: '',
    });
    this.cvvForm.get('cvv').setErrors(null);
  }

  private onPhoneSaved(phone: number) {
    if (!this.user) {
      return;
    }
    this.user.phone = phone;
    if (this.waitingForPhone) {
      this.waitingForPhone = false;
      if (this.isPH) {
        this.onCreatePHOrder();
      }
    }
  }

  onCheckUserCvv() {
    if (this.isAdminOrder || this.isPendingOrder) {
      this.isCvvConfirmed = true;
      this.checkExpressPrinterStatusIfNeeded();
      return;
    }
    if (this.cvvForm.invalid) {
      return;
    }
    const realCvv = this.user.zCreditInfo?.cvv
      ? String(this.user.zCreditInfo.cvv)
      : '';
    const inputCvv = String(this.cvvForm.value.cvv ?? '');
    if (inputCvv !== realCvv) {
      this.isCvvConfirmed = false;
      this.cvvForm.get('cvv').setErrors({ notMatch: true });
      this.tryCeckCvv++;
      if (this.tryCeckCvv > this.MaxCeckCvvTry - 1) {
        this.isLoading = true;
        this.isTooManyCvvTry = true;
        this.authService.logout();
        setTimeout(() => {
          this.dialogService.onOpenLoginDialog();
          this.closeOrderSummaryDialog();
        }, 12000);
      }
    } else {
      this.isCvvConfirmed = true;
      this.cvvForm.get('cvv').setErrors(null);
      if (this.emptyPaymentForOrder) {
        this.payEmptyPaymentRequestWithSavedCC();
        return;
      }
      this.checkExpressPrinterStatusIfNeeded();
      if (this.isPH && this.user.phone && this.user.phone !== '') {
        this.onCreatePHOrder();
      }
    }
  }

  // [express] - Check printer status when code input appears
  private checkExpressPrinterStatusIfNeeded() {
    if (this.emptyPaymentForOrder) {
      return;
    }
    if (this.printingService === 'express' && !this.hasCheckedExpressStatus && this.printerID) {
      this.hasCheckedExpressStatus = true;
      this.branchesService.checkExpressPrinterStatus(this.printerID, this.user?.email, this.user?.phone);
    }
  }

  // LOTTIE ANIMATION
  ngAfterViewInit() {
    this.animation = lottie.loadAnimation({
      container: document.getElementById('animationContainer'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: 'assets/videos/successfully.json',
    });

    this.animation.setSpeed(2.6);
  }

  playAnimation() {
    if (this.animation) {
      this.animation.play();
    }
    this.isLottieStart = false;
    this.isLottieEnd = false;
    this.isLottieMiddle = false;
    setTimeout(() => {
      this.isLottieStart = true;
      setTimeout(() => {
        this.isLottieMiddle = true;
        setTimeout(() => {
          this.isLottieEnd = true;
          this.animation.stop();
          this.isLottieStart = false;
          this.isLottieMiddle = false;
        }, 400);
      }, 1500);
    }, 0);
  }

  playConfettiAnimation() {
    // console.log("playConfettiAnimation");
    setTimeout(() => {
      this.confettiAnimation = lottie.loadAnimation({
        container: document.getElementById((this.isPH ? 'animationConfettiContainerPH' : 'animationConfettiContainer')),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: 'assets/videos/confetti.json',
      });
    }, 5);
  }

  scrollToTop() {
    const dialogElement = document.querySelector('.zx-max-100-vh');
    if (dialogElement) {
      dialogElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  private calculatePrintingCode(printerNum: number, randomDigits: number): number {
    let code = '00000';
    if (printerNum && randomDigits) {
      code =
        printerNum.toString().charAt(0) +
        randomDigits.toString().charAt(0) +
        printerNum.toString().charAt(1) +
        randomDigits.toString().charAt(1) +
        printerNum.toString().charAt(2);
    }
    return parseInt(code);
  }

  updatePrintingCode() {
    if (this.printingService === 'express' && this.printerID) {
      this.isLoadingPrintingCode = true;
      this.branchesService.getExpressPrintingCode(this.printerID).subscribe(
        (response) => {
          this.printingCode = this.calculatePrintingCode(response.unique, response.code);
          this.isLoadingPrintingCode = false;
        },
        (error) => {
          console.error('Error updating printing code:', error);
          this.isLoadingPrintingCode = false;
        }
      );
    }
  }

  focusPrintingCodeInput() {
    this.isAfterOptionBtnAnimated = false;
    if (this.printingService === 'express') {
      this.expressInput.nativeElement.focus();
    }
  }

  focusCVVInput() {
    this.isAfterOptionBtnAnimated = false;
    this.cvvInput.nativeElement.focus();
  }

  animateAfterOptionBtn() {
    if (!this.isAfterOptionBtnAnimated) {
      this.isAfterOptionBtnAnimated = true;
      setTimeout(() => {
        this.isAfterOptionBtnAnimated = false;
      }, 5000);
    }
  }

  getPrintingService(service: string) {
    if (service === 'plotter') {
      return 'plotter';
    } else {
      if (this.isPicsPrinter) {
        return 'pics';
      } else return 'express';
    }
  }

  getAmountOfFixProducts(products: any): number {
    let amount = 0;
    for (let i = 0; i < products.length; i++) {
      amount += products[i].numOfCopies;
    }
    return amount;
  }

  isIphone(): boolean {
    return /iPhone/.test(navigator.userAgent);
  }

  explainHowToChaingeSettings() {
    const text = this.isPendingOrder
      ? 'order-summary.can-not-edit-settings'
      : 'order-summary.how-to-edit-settings';
    const duration = this.isPendingOrder ? 5000 : 2500;
    this.snackBar.open(this.translate.instant(text), '', {
      duration: duration,
      verticalPosition: 'top',
      panelClass: 'zx-top-snackbar',
    });
  }

  copyOrderLink(): void {
    const text = this.translate.instant('order-summary.copy-link.text');
    const orderId = this.orderID;
    const service = this.printingService[0];
    const link = `https://print.eazix.io/x/${service}/${orderId}`;
    const orderNumber = this.orderID.slice(0, 8);
    const branchName = this.translate.instant(
      'choose-branch.naming.' + this.printingService + '.' + this.branchName
    );
    const finalText =
      text + ' ' + orderNumber + ' (' + branchName + '): ' + link;
    void copyTextToClipboard(finalText)
      .then(() => {
        this.snackBar.open(this.translate.instant('order-summary.copy-link.success'), '', {
          duration: 1200,
          panelClass: ['auto-width', 'center-text'].filter(Boolean),
          verticalPosition: 'top',
        });
      })
      .catch((err) => console.error('Could not copy text: ', err));
  }


  // PH --------------------------------------
  onCreatePHOrder() {
    console.log('[ORDER-SUMMARY] onCreatePHOrder called', {
      is3D: this.is3D,
      branchName: this.branchName,
      filesCount: this.files?.length
    });
    // Prevent double submission
    if (this.isLoading || this.isLoadingAproveOrderSummary) {
      console.warn('[ORDER-SUMMARY] Order creation already in progress, ignoring duplicate call');
      return;
    }
    
    console.log("NEW_PH_ORDER - files",
      this.files
    );
    console.log("NEW_PH_ORDER - printerID",
      this.printerID
    );
    console.log("NEW_PH_ORDER - branchName",
      this.branchName
    );
    console.log("NEW_PH_ORDER - user",
      this.user
    );
    console.log("NEW_PH_ORDER - totalPriceData",
      this.totalPriceData
    );
    console.log("NEW_PH_ORDER - fixProducts",
      this.fixProducts
    );
    console.log("NEW_PH_ORDER - fixProductsOrderId",
      this.fixProductsOrderId
    );
    console.log("NEW_PH_ORDER - expressAttachedOrderId",
      this.expressAttachedOrderId
    );
    console.log("NEW_PH_ORDER - picsDiscount",
      this.picsDiscount
    );
    console.log("NEW_PH_ORDER - collectionData",
      this.collectionData
    );
    console.log("NEW_PH_ORDER - selectedPlace",
      this.selectedPlace
    );
    console.log("SENT!!!!!!!!!!!!!!!!!!!!!!!!!!!!");

    this.isLoading = true;
    this.isLoadingAproveOrderSummary = true;

    // ---- DEMO! ----
    // setTimeout(() => {
    //   console.log("RESPONSE!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    //   setTimeout(() => {
    //     this.isLoading = false;
    //     setTimeout(() => {
    //       this.playConfettiAnimation();
    //     }, 50);
    //   }, 1000);
    // }, 1000);
    // return;

    // ---- REAL! ----
    if (this.is3D) {
      const allDataFor3DOrder = {
        files: this.files,
        branchName: this.branchName,
        userId: this.user?._id,
        totalOrderPrice: this.totalPriceData?.totalOrderPrice,
        collectionData: this.collectionData,
        selectedPlace: this.selectedPlace,
        user: this.user,
        totalPriceData: this.totalPriceData,
        printerID: this.printerID,
        orderID: this.orderID,
        branchUnique: this.branchUnique,
        fixProducts: this.fixProducts,
        product3D: this.product3D,
      };
      console.log('ALL-DATA-FOR-3D-ORDER-CREATION', JSON.stringify(allDataFor3DOrder, null, 2));
    }
    // עבור 3D – המחיר הכולל כולל משלוח (הדפסה ממתינה להצעת מחיר); יש לשלוח את הסכום האמיתי
    const totalCostForBackend = this.totalPriceData?.totalOrderPrice ?? 0;
    this.ordersService.createPHOrder(
      this.files,
      this.branchName,
      this.user._id,
      totalCostForBackend,
      this.collectionData,
      this.selectedPlace
    ).subscribe(
      (response: any) => {
        console.log("PH Order created successfully:", response);
        this.orderID = response?.order?._id ?? response?.orderId ?? response?._id ?? this.orderID;
        this.dataSharingService.notifyPhOrderCreated();
        this.dataSharingService.notifyPendingOrderIncrement();
        this.isOrderPrinted = true;
        setTimeout(() => {
          this.isLoading = false;
          this.isLoadingAproveOrderSummary = false;
          setTimeout(() => {
            this.playConfettiAnimation();
          }, 50);
        }, 1000);
      },
      (error) => {
        this.isLoading = false;
        this.isLoadingAproveOrderSummary = false;
        this.isCreditMode = true;
        this.isCreditCardFieldsEmphasized = false;
        console.error("Error creating PH Order:", error);
        // טיפול בשגיאה
      }
    );
  }
  // // PH --------------------------------------

  // Get display file name after split('-')[1] - returns originalFileName if exists, otherwise uses name.split('-')[1]
  getDisplayFileNameAfterSplit(file: any): string {
    if (!file) {
      return '';
    }
    // If originalFileName exists, return it as is (assuming it's already the clean name)
    if (file.originalFileName && file.originalFileName.trim() !== '') {
      return file.originalFileName;
    }
    // For name, use the existing split logic
    if (!file.name) {
      return '';
    }
    const parts = file.name.split('-');
    return parts.length > 1 ? parts[1] : file.name;
  }

  orderSummaryPhPaperTypeNameKey(paperType: string | null | undefined): string {
    return phProductMaterialI18nKey(this.branchName, paperType ?? '');
  }

  // ====================================
}
